import { Grid, Typography } from "@mui/material";
import React from "react";
import colors from "../../../../../colors";
import { texts } from "../../../../../general/texts";

const MyContractsOfflineTaxes = () => {
  return (
    <>
      <Typography
        sx={{
          fontFamily: "GerberaBold",
          color: colors.darkBlue,
          fontSize: "1.2rem",
          mt: 25,
        }}
      >
        {texts["message-cannot-save-contracts"]}
      </Typography>
    </>
  );
};

export default MyContractsOfflineTaxes;
